module.exports = __webpack_public_path__ + "static/signin-image-2@2x-bb572025d7059c521fa5c22cc7ce26f2.jpg";